module.exports = __webpack_public_path__ + "img/login-v2-dark.684bd68d.svg";